import React from 'react';
import Typography from '@material-ui/core/Typography';
import { BUSINESSES } from '../../routing';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import PlanCard from '../../../front/Plans/Card';
import BusinessCard from '../../../front/Businesses/Card';
import { Covid19Button } from '../../covid19';
import LargeButton from './LargeButton';
import type { BusinessProps, PlanProps } from '../index';
import SectionContainer from './SectionContainer';
import SectionTitle from './SectionTitle';

type OtherPlansProps = {
  plans: Array<PlanProps>,
  businesses: Array<BusinessProps>,
  isAuthenticated: boolean,
};

const useStyles = makeStyles((theme) => ({
  subtitle: {
    fontWeight: 'bold',
    fontSize: 20,
    margin: theme.spacing(4, 0, 2),
  },
  buttonContainer: {
    textAlign: 'center',
    maxWidth: 500,
    margin: 'auto',
    padding: theme.spacing(4, 0),
  },
}));

const OtherPlans = ({
  plans,
  businesses,
  isAuthenticated,
}: OtherPlansProps) => {
  const classes = useStyles();
  return (
    <SectionContainer>
      <SectionTitle title="佐賀県のおてつたび" subtitle="OTETSUTABI" />
      <Typography variant="h3" className={classes.subtitle}>
        現在募集中の佐賀県のおてつたび
      </Typography>
      <Grid container spacing={2}>
        {plans.map((plan, idx) => (
          <Grid item xs={6} sm={4} md={3} key={idx}>
            <PlanCard {...plan} isAuthenticated={isAuthenticated} />
          </Grid>
        ))}
      </Grid>
      <Typography variant="h3" className={classes.subtitle}>
        すべての佐賀県のおてつたび先
      </Typography>
      <Grid container alignItems="center" spacing={2}>
        {businesses.map((business, idx) => (
          <Grid item xs={6} sm={4} md={3} key={idx}>
            <BusinessCard {...business} />
          </Grid>
        ))}
      </Grid>
      <div className={classes.buttonContainer}>
        <LargeButton fullWidth href={BUSINESSES + '?feature=saga'}>
          おてつたび先一覧はこちら
        </LargeButton>
        <Covid19Button />
      </div>
    </SectionContainer>
  );
};

export default OtherPlans;
